export enum HttpHeader {
  AUTHORIZATION = 'Authorization',
  ACCEPT = 'Accept',
  API_KEY = 'Api-Key',
  CONTENT_TYPE = 'Content-Type',
}
